import { array } from 'fp-ts';
import { flow } from 'fp-ts/function';
import { filter, map } from 'lodash/fp';

import { Amount } from '@mews-distributor/common';

import { Settlement } from '../../modules/entities/reservationPrices/types';
import { isImmediatelySettled, isImmediatelySettledWithPreauthorizations } from './isImmediatelySettled';

export const getImmediatelySettledAmounts = flow<[Array<Settlement>], Array<Settlement>, Array<Amount>>(
    filter(({ isTriggeredOnConfirmation, type, action }) =>
        isImmediatelySettled({ isTriggeredOnConfirmation, settlementType: type, action })
    ),
    map('amount')
);

export const getImmediatelySettledAmountsWithPreauthorizations = flow(
    array.filter<Settlement>(({ isTriggeredOnConfirmation, type }) =>
        isImmediatelySettledWithPreauthorizations({ isTriggeredOnConfirmation, settlementType: type })
    ),
    array.map((settlement) => settlement.amount)
);
